import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDriver = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.9991 13.671C13.8344 14.0831 13 15.1941 13 16.5C13 16.6682 13.0138 16.833 13.0402 16.9932L14.0831 16.4321C14.1062 15.7687 14.4666 15.191 14.9981 14.8654L14.9991 13.671ZM16.9991 13.6704L16.9981 14.866C17.5289 15.1917 17.8887 15.7688 17.912 16.4314L18.9596 16.9941C18.9862 16.8336 19 16.6686 19 16.5C19 15.1934 18.1648 14.0819 16.9991 13.6704ZM17.9912 18.7442L16.9295 18.1739C16.6539 18.3277 16.3361 18.4157 15.9976 18.4157C15.6592 18.4157 15.3417 18.3278 15.0662 18.1742L14.0081 18.7435C14.5385 19.2148 15.2362 19.5 16 19.5C16.7634 19.5 17.4609 19.215 17.9912 18.7442ZM11 16.5C11 13.7386 13.2386 11.5 16 11.5C18.7614 11.5 21 13.7386 21 16.5C21 17.3699 20.777 18.1907 20.3843 18.9053C19.5355 20.4497 17.8911 21.5 16 21.5C14.1089 21.5 12.4645 20.4497 11.6157 18.9053C11.223 18.1907 11 17.3699 11 16.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 7.5C5 4.73858 7.23858 2.5 10 2.5C12.7614 2.5 15 4.73858 15 7.5C15 9.02032 14.3215 10.3822 13.2507 11.2992C13.4644 11.4114 13.6715 11.5343 13.8715 11.6673C13.9596 11.7259 14.0354 11.796 14.0982 11.8744C13.43 12.1494 12.8344 12.565 12.3484 13.0845C11.6488 12.7114 10.8501 12.5 10 12.5C7.23858 12.5 5 14.7386 5 17.5C5 18.0523 4.55228 18.5 4 18.5C3.44772 18.5 3 18.0523 3 17.5C3 14.8075 4.52021 12.47 6.74913 11.2991C5.67847 10.382 5 9.02024 5 7.5ZM10 4.5C8.34315 4.5 7 5.84315 7 7.5C7 9.15685 8.34315 10.5 10 10.5C11.6569 10.5 13 9.15685 13 7.5C13 5.84315 11.6569 4.5 10 4.5Z",
		fill: "currentColor"
	})]
});
export default SvgDriver;
